import moment from "moment";

export default {
  methods: {
    formatDate(date, includeTime = true) {
      if (includeTime) return moment(date).format("D MMM YYYY, h:mma");
      return moment(date).format("D MMM YYYY");
    },
    timeFrom(date) {
      return moment(date).from(moment());
    },
    timeFromNoFuture(date) {
      if (moment(date).isBefore(moment())) {
        return (
          " by approximately " + moment(date).format("h:mma on D MMM YYYY")
        );
      } else {
        return " within approximately " + moment(date).from(moment(), true);
      }
    },
  },
};
